import React, { useState, useEffect } from "react";

// 洗牌工具
function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function SentenceMakingGame({ targetSentence, onFinish }) {
  const words = targetSentence.trim().split(" ");
  // scrambled: 還沒被選的字
  const [bank, setBank] = useState([]);
  // answer: 下排，每個格子已選的字(字串)，未填null
  const [answer, setAnswer] = useState(Array(words.length).fill(null));

  // 初始化
  useEffect(() => {
    setBank(shuffleArray(words));
    setAnswer(Array(words.length).fill(null));
  }, [targetSentence]);

  // 點擊 bank 字，填到 answer 下一格
  function handlePick(w) {
    // 找下一個空格
    const idx = answer.findIndex(v => v === null);
    if (idx === -1) return;
    // 寫進答案
    const newAns = [...answer];
    newAns[idx] = w;
    setAnswer(newAns);
    // bank 移除該字
    setBank(bank.filter(x => x !== w));
  }

  // 點擊下排 answer 字，可取消選取
  function handleUnpick(i) {
    if (answer[i] === null) return;
    setBank([...bank, answer[i]]);
    const newAns = [...answer];
    newAns[i] = null;
    setAnswer(newAns);
  }

  // 檢查答案
  function handleSubmit() {
    const ok = answer.join(" ") === targetSentence;
    if (onFinish) onFinish(ok ? answer.length : 0, answer.length);
  }

  return (
    <div style={{ textAlign: "center" }}>
      <h3>Make a Sentence!</h3>
      <p>
        <span style={{ color: "#1788bb", fontWeight: 500 }}>
          Drag the words below into the correct order to form a sentence.
        </span>
      </p>
      <div style={{ margin: 10 }}>
        {bank.map((w, i) => (
          <span
            key={i}
            onClick={() => handlePick(w)}
            style={{
              display: "inline-block",
              margin: 8,
              padding: "8px 16px",
              background: "#FFD88E",
              borderRadius: 7,
              cursor: "pointer",
              fontWeight: 600,
              minWidth: 35,
              textAlign: "center",
              border: "1px solid #d9a74d",
              boxShadow: "1px 1px 3px #eee"
            }}
          >
            {w}
          </span>
        ))}
      </div>
      <div style={{
        margin: "30px auto 10px",
        width: 380, minHeight: 50,
        border: "2px solid #E23",
        borderRadius: 10,
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center"
      }}>
        {answer.map((w, i) => (
          <div
            key={i}
            onClick={() => handleUnpick(i)}
            style={{
              width: 70, height: 40,
              border: "2px dashed #bbb",
              borderRadius: 6,
              background: w ? "#f8f8f8" : "#fafafa",
              textAlign: "center",
              lineHeight: "40px",
              fontWeight: 700,
              fontSize: 18,
              margin: 2,
              cursor: w ? "pointer" : "default",
              color: "#222"
            }}
            title={w ? "點擊取消" : ""}
          >
            {w}
          </div>
        ))}
      </div>
      <button
        className="button1"
        onClick={handleSubmit}
        disabled={answer.includes(null)}
        style={{ marginTop: 12, minWidth: 120 }}
      >
        Submit
      </button>
    </div>
  );
}
